'use client';

import { createContext, useContext } from 'react';
import type { KindType } from '@/app/cc/_types/types';

const KindContext = createContext<KindType | null>(null);

export function KindProvider({
  kind,
  children,
}: Readonly<{
  kind: KindType;
  children: React.ReactNode;
}>) {
  return <KindContext.Provider value={kind}>{children}</KindContext.Provider>;
}

export function useKind() {
  const kind = useContext(KindContext);

  if (kind === null) {
    throw new Error('useKind must be used within KindProvider');
  }

  return kind;
}
